export const OPEN_DIALOG_DELAY_MS = 30_000
